import { Routes } from "@angular/router";

export const CATALOG_ROUTES: Routes = [
  // Client routes
  {
    path: "client/list",
    loadComponent: () =>
      import("./client/pages/client-list/clients-list.component").then(
        (m) => m.ClientsListComponent,
      ),
    title: "Clients Catalog - Foresight",
    data: {
      breadcrumb: "Clients",
      breadcrumbModule: "Catalog",
      breadcrumbTrail: [{ label: "Clients", reload: true }],
      pageId: "clients-catalog",
    },
  },
  {
    path: "client/create",
    loadComponent: () =>
      import("./client/pages/client-form/client-form.component").then(
        (m) => m.ClientFormComponent,
      ),
    title: "Add New Client - Foresight",
  },
  {
    path: "client/view/:id",
    loadComponent: () =>
      import("./client/pages/view-client/view-client.component").then(
        (m) => m.ViewClientComponent,
      ),
    title: "Client Details - Foresight",
  },
  {
    path: "client/edit/:id",
    loadComponent: () =>
      import("./client/pages/client-form/client-form.component").then(
        (m) => m.ClientFormComponent,
      ),
    title: "Edit Client - Foresight",
  },
  {
    path: "client/draft/:id",
    loadComponent: () =>
      import("./client/pages/client-form/client-form.component").then(
        (m) => m.ClientFormComponent,
      ),
    title: "Continue Client Draft - Foresight",
    data: {
      isDraft: true,
    },
  },
  // Vendor routes
  {
    path: "vendor/list",
    loadComponent: () =>
      import("./vendor/pages/vendor-list/vendor-list.component").then(
        (m) => m.VendorListComponent,
      ),
    title: "Vendor Catalog - Foresight",
    data: {
      breadcrumb: "Vendor",
      breadcrumbModule: "Catalog",
      breadcrumbTrail: [{ label: "Vendor", reload: true }],
      pageId: "vendor-catalog",
    },
  },
  {
    path: "vendor/create",
    loadComponent: () =>
      import("./vendor/pages/vendor-form/vendor-form.component").then(
        (m) => m.VendorFormComponent,
      ),
    title: "Add New Vendor - Foresight",
  },
  {
    path: "vendor/view/:id",
    loadComponent: () =>
      import("./vendor/pages/view-vendor/view-vendor.component").then(
        (m) => m.ViewVendorComponent,
      ),
    title: "Vendor Details - Foresight",
  },
  {
    path: "vendor/edit/:id",
    loadComponent: () =>
      import("./vendor/pages/vendor-form/vendor-form.component").then(
        (m) => m.VendorFormComponent,
      ),
    title: "Edit Vendor - Foresight",
  },
  {
    path: "vendor/draft/:id",
    loadComponent: () =>
      import("./vendor/pages/vendor-form/vendor-form.component").then(
        (m) => m.VendorFormComponent,
      ),
    title: "Continue Vendor Draft - Foresight",
    data: {
      mode: "draft",
    },
  },
  { path: "", redirectTo: "client/list", pathMatch: "full" },
];
